"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;
var _react = _interopRequireDefault(require("react"));
function _interopRequireDefault(e) { return e && e.__esModule ? e : { default: e }; }
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
const questioncircle = _ref => {
  let {
    title,
    description,
    ...props
  } = _ref;
  return /*#__PURE__*/_react.default.createElement("svg", _extends({}, props, {
    viewBox: "0 0 24 24",
    xmlns: "http://www.w3.org/2000/svg",
    "aria-labelledby": (title ? `title-questioncircle` : '') + (description ? ` desc-questioncircle` : '') || undefined,
    role: "img"
  }), title && /*#__PURE__*/_react.default.createElement("title", {
    id: "title-questioncircle"
  }, title), description && /*#__PURE__*/_react.default.createElement("desc", {
    id: "desc-questioncircle"
  }, description), /*#__PURE__*/_react.default.createElement("g", {
    clipPath: "url(#clip0_972_2234)"
  }, /*#__PURE__*/_react.default.createElement("path", {
    d: "M12 0.251007C18.4893 0.251007 23.75 5.51166 23.75 12.001C23.75 18.4904 18.4893 23.751 12 23.751C5.51065 23.751 0.25 18.4904 0.25 12.001C0.25 5.51166 5.51065 0.251007 12 0.251007ZM12 1.75101C6.33908 1.75101 1.75 6.34009 1.75 12.001C1.75 17.6619 6.33908 22.251 12 22.251C17.6609 22.251 22.25 17.6619 22.25 12.001C22.25 6.34009 17.6609 1.75101 12 1.75101ZM12 16.9L12.1166 16.9067C12.614 16.9645 13 17.3872 13 17.9C13 18.4523 12.5523 18.9 12 18.9C11.4477 18.9 11 18.4523 11 17.9C11 17.3872 11.386 16.9645 11.8834 16.9067L12 16.9ZM15.6098 8.98971C16.1171 10.7925 15.2165 12.6933 13.5 13.4424C13.0859 13.6231 12.8049 14.0113 12.7572 14.4538L12.75 14.588V15C12.75 15.4142 12.4142 15.75 12 15.75C11.6203 15.75 11.3065 15.4679 11.2568 15.1018L11.25 15V14.588C11.25 13.5589 11.8239 12.6218 12.7269 12.1504L12.9 12.0676C13.9299 11.6181 14.4703 10.4777 14.1659 9.39601C13.8615 8.31431 12.8057 7.62302 11.6926 7.77657C10.6324 7.9228 9.82979 8.79262 9.7556 9.84583L9.75 10.0051C9.74994 10.4193 9.4141 10.7551 8.99989 10.755C8.58567 10.7549 8.25 10.4191 8.25 10.0049C8.25028 8.13204 9.63231 6.54655 11.4876 6.29064C13.3429 6.03472 15.1025 7.18687 15.6098 8.98971Z",
    fill: "inherit"
  })), /*#__PURE__*/_react.default.createElement("defs", null, /*#__PURE__*/_react.default.createElement("clipPath", {
    id: "clip0_972_2234"
  }, /*#__PURE__*/_react.default.createElement("rect", {
    width: "24",
    height: "24",
    fill: "white"
  }))));
};
var _default = exports.default = questioncircle;